import ChampionshipSetup from "./ChampionshipSetup";

export default ChampionshipSetup;
